import {Table, TableCaption, TableContainer, TableContainerProps, Tbody, Td, Th, Thead, Tooltip, Tr} from "@chakra-ui/react";
import {FC} from "react";
import "../../../styles/list.css";

export type Header = {
    title: string,
    type?: "text" | "numeric",
    tooltip?: string
}

export type Field = {
    data?: string
    element?: JSX.Element
    disableOnClick?: boolean
    noWrap?: boolean
}

export type RowData = {
    id: string,
    fields: Field[],
    rowClassName?: string
}

type Props = {
    caption?: string
    headers: Header[]
    rows: RowData[]
    onClick?: (id: string) => void
    containerProps?: TableContainerProps
    stickyHeader?: boolean
}

export const TableInternal: FC<Props> = ({caption, headers, rows, onClick, containerProps, stickyHeader}) => {
    return <TableContainer {...containerProps} width={"100%"}>
        <Table width={"max-content"} minWidth={"100%"}>
            {caption ? <TableCaption placement="top">Some caption</TableCaption>
                : <></>}
            <Thead>
                <Tr>
                    {headers.map((header: Header, indx: number) => {
                        return <Th
                            key={indx}
                            position={stickyHeader ? "sticky" : undefined}
                            top={stickyHeader ? 0 : undefined}
                            zIndex={stickyHeader ? 1 : undefined}
                            background={stickyHeader ? "white" : undefined}
                        >
                            {header.tooltip ? (
                                <Tooltip label={header.tooltip}>
                                    <span>{header.title}</span>
                                </Tooltip>
                            ) : header.title}
                        </Th>
                    })}
                </Tr>
            </Thead>
            <Tbody>
                {rows.map((rowData: RowData) => {
                    const baseClass = onClick ? "tableRow-clickable" : "tableRow";
                    const rowClassName = rowData.rowClassName ? `${baseClass} ${rowData.rowClassName}` : baseClass;
                    return <Tr key={rowData.id} className={rowClassName}>
                        {rowData.fields?.map((field: Field, index: number) => {
                            return <Td key={rowData.id + "." + index}
                                       whiteSpace={field.noWrap ? "nowrap" : undefined}
                                       onClick={() => !field.disableOnClick && onClick && onClick(rowData.id)}>
                                {field.element ? field.element : field.data}
                            </Td>
                        })
                        }
                    </Tr>
                })}
            </Tbody>
        </Table>
    </TableContainer>
}
